import React from 'react';
import { useRouter } from 'next/router';
// Types
import { GetAllHomePageData_featuredPpvEvents } from 'api/homePage/types/GetAllHomePageData';
// Components
import Heroshot from './Heroshot/Heroshot';
import MainPageContentSection from './EventsCta/VideoBackgroundSection';
import DownloadAppSection from './GetAppCta/GetApp/DownloadAppSection';
import PhoneAppDownloadCta from './GetAppCta/GetPhonesCta/GetPhonesCta';
import ImageGridCarousel from './ImageGridCarousel/ImageGridCarousel';
import CardLayout from './MainCards/MainCardsLayout/MainCardsLayout';
import FeaturedStreamsCarousel from './FeaturedStreamsCarousel/FeaturedStreamsCarousel';
// Hooks
import { useAppContext, useGetCurrUser } from 'hooks';
// Constants
import { DASHBOARD } from 'constants/routes';
// Layouts
import Footer from 'layouts/Footer/Footer';
// Helpers
import { getSlideContent } from './helpers/SlideHelper';

interface NoAnimationHomePageProps {
  banners: any[];
  cardsData: any[];
  featuredStreams: GetAllHomePageData_featuredPpvEvents[];
}

const NoAnimationHomePage = ({
  banners,
  cardsData,
  featuredStreams,
}: NoAnimationHomePageProps) => {
  const { push } = useRouter();
  const { setSignUpModalVisibility, setSignUpStep } = useAppContext();

  const { data: currentUser } = useGetCurrUser();
  const isLoggedIn = Boolean(currentUser?.me?.id);

  const onButtonClick = () => {
    if (isLoggedIn) {
      push(DASHBOARD);
    } else {
      setSignUpStep(0);
      setSignUpModalVisibility(true);
    }
  };

  return (
    <div>
      <Heroshot banners={banners} />
      <FeaturedStreamsCarousel featuredStreams={featuredStreams} />
      <CardLayout cards={cardsData} onButtonClick={onButtonClick} />
      <PhoneAppDownloadCta />
      <MainPageContentSection {...getSlideContent(1)} />
      <MainPageContentSection {...getSlideContent(2)} />
      <MainPageContentSection {...getSlideContent(3)} />
      <MainPageContentSection {...getSlideContent(4)} />
      <ImageGridCarousel imageCount={16} onButtonClick={onButtonClick} />
      <DownloadAppSection />
      <Footer />
    </div>
  );
};

export default NoAnimationHomePage;
